import React from 'react';
import { Link } from 'react-router-dom';

import './faqs.css';
import './whatwedo-services.css';
import './animations.css';
import useScrollAnimation from './hooks/useScrollAnimation';
import useScrollFade from './hooks/useScrollFade';

export default function WhatWeDo() {
  const [heroRef, heroVisible] = useScrollAnimation(0.3);
  const [servicesRef, servicesVisible] = useScrollAnimation(0.2);
  const [sustainRef, sustainVisible] = useScrollAnimation(0.2);
  const [ctaInnerRef, ctaInnerStyle] = useScrollFade({ inOffset: 0.25, outOffset: 0.25, translate: 28 });
  return (
    <>
          <section className="studio-page-btw-studio-hero btw-studio-hero--center" ref={heroRef}>
      <div className="studio-page-btw-studio-hero-inner btw-studio-hero-inner">
        <div className="studio-page-btw-studio-hero-copy btw-studio-hero-copy">
          <div className={`studio-page-btw-studio-subtitle btw-studio-subtitle subtitle-animate ${heroVisible ? 'visible' : ''}`}>Crafting With Intent</div>
          <h1 
            className={`studio-page-btw-studio-hero-title btw-studio-hero-title hero-title-animate ${heroVisible ? 'visible' : ''}`}
            style={{ textAlign: 'center' }}
          >
            Spaces that elevate living<br/>  into experience
          </h1>
          <p 
            className={`studio-page-btw-studio-hero-desc btw-studio-hero-desc description-animate ${heroVisible ? 'visible' : ''}`}
            style={{ textAlign: 'center', margin: '0 auto', display: 'block', maxWidth: '700px' }}
          >
            Our work spans across homes, workplaces, and lifestyle spaces <br/> each crafted with an eye for detail, functionality, and timeless elegance.
          </p>
        </div>
      </div>
    </section>


      <section className="whatwedo-services-section" ref={servicesRef}>
        <div className="container" style={{maxWidth: '1200px', margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 20px', boxSizing: 'border-box'}}>
          <div className="whatwedo-hero-image-wrapper">
            <img src={process.env.PUBLIC_URL + '/Hero image.png'} alt="Hero" className={`whatwedo-hero-image fade-in-scale ${servicesVisible ? 'visible' : ''}`} />
          </div>
          
          {/* 2-Column Grid for Services */}
          <div className="whatwedo-services-grid" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', width: '100%', maxWidth: '1200px', marginTop: '32px', marginLeft: 'auto', marginRight: 'auto'}}>
            {/* Service 1 */}
            <div className={`whatwedo-service fade-in-up ${servicesVisible ? 'visible' : ''}`} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',  padding: '32px', gap: '0px', width: '100%', maxWidth: '500px'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '12px', width: '100%', marginBottom: '16px'}}>
                <script src="https://cdn.lordicon.com/lordicon.js"></script>
<lord-icon
    src="https://cdn.lordicon.com/jeuxydnh.json"
    trigger="loop"
    delay="1000"
    state="morph-mantion"
    colors="primary:#baa170,secondary:#121331"
    style={{width:'75px',height:'75px'}}>
</lord-icon>
                <div style={{fontSize:'1.2rem', color: '#baa170', fontWeight: 600, fontFamily: 'Inter, sans-serif'}}>Residential</div>
              </div>
              <div className={`whatwedo-service-content description-animate ${servicesVisible ? 'visible' : ''}`} style={{fontSize: '0.95rem', lineHeight: '1.6', color: '#181816', width: '100%', marginBottom: '16px'}}>
                We create homes that tell your story. From cozy apartments to expansive villas, every residence we design reflects the personality and lifestyle of its inhabitants. Comfort, elegance, and warmth form the foundation of our approach, ensuring your home feels both personal and timeless.
              </div>
              <ul className="whatwedo-service-list" style={{margin: '0', paddingLeft: '0px', fontSize: '0.9rem', lineHeight: '1.8', width: '100%'}}>
                <li>Space Planning & Layouts</li>
                <li>Bespoke Furniture & Décor</li>
                <li>Lighting & Material Selection</li>
                <li style={{borderBottom: '1px solid #baa170', paddingBottom: '16px'}}>Smart & Sustainable Living</li>
              </ul>
            </div>

            {/* Service 2 */}
            <div className={`whatwedo-service fade-in-up ${servicesVisible ? 'visible' : ''}`} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',  padding: '32px', gap: '0px', width: '100%', maxWidth: '500px'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '12px', width: '100%', marginBottom: '16px'}}>
<lord-icon
    src="https://cdn.lordicon.com/tjjwskjx.json"
    trigger="loop"
    delay="2000"
    colors="primary:#baa170,secondary:#121331"
    style={{width:'75px',height:'75px'}}>
</lord-icon>
                <div style={{fontSize:'1.2rem', color: '#baa170', fontWeight: 600, fontFamily: 'Inter, sans-serif'}}>Commercial</div>
              </div>
              <div className={`whatwedo-service-content description-animate ${servicesVisible ? 'visible' : ''}`} style={{fontSize: '0.95rem', lineHeight: '1.6', color: '#181816', width: '100%', marginBottom: '16px'}}>
                We believe that workspaces should do more than function - they should inspire. Our commercial interiors are designed to balance efficiency with style, making them environments that elevate productivity, foster creativity, and leave a lasting impression on clients.
              </div>
              <ul className="whatwedo-service-list" style={{margin: '0', paddingLeft: '0px', fontSize: '0.9rem', lineHeight: '1.8', width: '100%'}}>
                <li>Office & Workspace Design</li>
                <li>Retail & Hospitality Concepts</li>
                <li>Brand Integration</li>
                <li style={{borderBottom: '1px solid #baa170', paddingBottom: '16px'}}>Flexible & Collaborative Spaces</li>
              </ul>
            </div>

            {/* Service 3 */}
            <div className={`whatwedo-service fade-in-up ${servicesVisible ? 'visible' : ''}`} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',  padding: '32px', gap: '0px', width: '100%', maxWidth: '500px'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '12px', width: '100%', marginBottom: '16px'}}>
                <script src="https://cdn.lordicon.com/lordicon.js"></script>          
<lord-icon
    src="https://cdn.lordicon.com/ehcxqqor.json"
    trigger="loop"
    delay="2000"
    colors="primary:#baa170,secondary:#121331"
    style={{width:'75px',height:'75px'}} >
</lord-icon>
                <div style={{fontSize:'1.2rem', color: '#baa170', fontWeight: 600, fontFamily: 'Inter, sans-serif'}}>Lifestyle</div>
              </div>
              <div className={`whatwedo-service-content description-animate ${servicesVisible ? 'visible' : ''}`} style={{fontSize: '0.95rem', lineHeight: '1.6', color: '#181816', width: '100%', marginBottom: '16px'}}>
                Delivering bold, functional spaces for customer-focused businesses. From dynamic retail settings to efficient service environments, our designs enhance user experience, improve workflow, and bring modern architectural innovation to every space.
              </div>
              <ul className="whatwedo-service-list" style={{margin: '0', paddingLeft: '0px', fontSize: '0.9rem', lineHeight: '1.8', width: '100%'}}>
                <li>Customer-Focused Environments</li>
                <li>Service-Optimized Layouts</li>
                <li>Flexible & Compact Space Solutions</li>
                <li style={{borderBottom: '1px solid #baa170', paddingBottom: '16px'}}>Experience-Driven Design</li>
              </ul>
            </div>

            {/* Service 4 */}
            <div className={`whatwedo-service fade-in-up ${servicesVisible ? 'visible' : ''}`} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left', padding: '32px', gap: '0px', width: '100%', maxWidth: '500px'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '12px', width: '100%', marginBottom: '16px'}}>
              <lord-icon
    src="https://cdn.lordicon.com/jkpegboq.json"
    trigger="loop"
    delay="2000"
    colors="primary:#baa170,secondary:#121331"
    style={{width:'75px',height:'75px'}}>
</lord-icon>
                <div style={{fontSize:'1.2rem', color: '#baa170', fontWeight: 600, fontFamily: 'Inter, sans-serif'}}>Turnkey</div>
              </div>
              <div className={`whatwedo-service-content description-animate ${servicesVisible ? 'visible' : ''}`} style={{fontSize: '0.95rem', lineHeight: '1.6', color: '#181816', width: '100%', marginBottom: '16px'}}>
                Creating spaces that support communities and everyday life. Through complete turnkey solutions, we handle every stage from planning to handover to deliver environments that blend functionality, culture, and modern innovation with lasting quality.
              </div>
              <ul className="whatwedo-service-list" style={{margin: '0', paddingLeft: '0px', fontSize: '0.9rem', lineHeight: '1.8', width: '100%'}}>
                <li>End-to-End Project Delivery</li>
                <li>Integrated Design & Build Solutions</li>
                <li>Restoration & Revitalization Services</li>
                <li style={{borderBottom: '1px solid #baa170', paddingBottom: '16px'}}>Modern Structural & Architectural Works</li>
              </ul>
            </div>
          </div>
          
          <style>{`
            @media (max-width: 768px) {
              div[style*="gridTemplateColumns: '1fr 1fr'"] {
                grid-template-columns: 1fr !important;
                gap: 24px !important;
                padding: 0 16px !important;
                box-sizing: border-box !important;
              }
              div[style*="maxWidth: '500px'"] {
                max-width: 100% !important;
                padding: 24px 16px !important;
              }
            }
          `}</style>
        </div>
      </section>
      
            <section className="whatwedo-sustainability-section whatwedo-page-sustainability-section" ref={sustainRef}>
        <div className="whatwedo-sustainability-inner" style={{maxWidth: '900px', margin: '0 auto', display: 'flex', alignItems: 'stretch', gap: window.innerWidth < 768 ? '0px' : '32px', flexDirection: window.innerWidth < 768 ? 'column-reverse' : 'row', justifyContent: 'center', padding: window.innerWidth < 768 ? '0 12px' : '0'}}>
          <div className="whatwedo-sustainability-left" style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', marginBottom: window.innerWidth < 768 ? '24px' : '0'}}>
            <div className="whatwedo-sustainability-top">
              <div className={`whatwedo-sustainability-label subtitle-animate ${sustainVisible ? 'visible' : ''}`} style={{fontSize: '0.8rem'}}>Founder's Note</div>
              <div className={`whatwedo-sustainability-title hero-title-animate ${sustainVisible ? 'visible' : ''}`} style={{color: '#181816', fontFamily: 'instrument serif, serif'}}>Evolution starts with design</div>
            </div>
            <div className="whatwedo-sustainability-desc-author-box">
              "Every transformation begins with a vision-design is the catalyst that turns ideas into progress. It shapes how we live, work, and interact, laying the foundation for innovation and meaningful change. When design leads, evolution follows, creating solutions that are smarter, more human-centered, and built for the future."
              <div className="whatwedo-sustainability-author">Abhishek Dave @ Between The Walls, Pune</div>
            </div>
          </div>
          <div className="whatwedo-sustainability-right" style={{display: 'flex', justifyContent: 'center', width: window.innerWidth < 768 ? '100%' : 'auto'}}>
            <img src={process.env.PUBLIC_URL + '/Abhishek Dave 1.jpg'} alt="Sustainability" className={`whatwedo-sustainability-image fade-in-scale ${sustainVisible ? 'visible' : ''}`} style={{height: '400px', width: 'auto', borderRadius: '8px'}} />
          </div>
        </div>
      </section>

      <section className="btw-getstarted-section bg-neutral-900 min-h-[60vh] flex flex-col justify-center items-center text-center">
        <div className="btw-getstarted-inner" ref={ctaInnerRef} style={ctaInnerStyle}>
          <div className="text-neutral-400 font-mono mb-6" style={{fontSize: '0.8rem'}}>GET  STARTED</div>
          <h1 className="text-5xl md:text-7xl font-bold text-[#181816] mb-8 leading-tight">TRANSFORM YOUR<br />VISION INTO REALITY</h1>
          <Link to="/letstalk" style={{textDecoration: 'none'}}>
            <button className="btw-cta" type="button"><span>LET'S TALK</span></button>
          </Link>
        </div>
      </section>
    </>
  );
}
